export default __webpack_public_path__ + "static/media/fa.e0f58af7.svg";